// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.0
//   protoc               unknown
// source: common/model/ModifiersPt.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "io.teamsillim.fightbracket.idl.common.model";

/** 수정 정보 */
export interface ModifiersPayload {
  /** 생성자 (notNull, length = 50) */
  createdBy: string;
  /** 생성일 (notNull, format = yyyy-MM-dd'T'HH:mm:ss'Z') */
  createdAt: string;
  /** 수정자 (nullable, length = 50) */
  modifiedBy: string;
  /** 수정일 (notNull, format = yyyy-MM-dd'T'HH:mm:ss'Z') */
  modifiedAt: string;
}

function createBaseModifiersPayload(): ModifiersPayload {
  return { createdBy: "", createdAt: "", modifiedBy: "", modifiedAt: "" };
}

export const ModifiersPayload: MessageFns<ModifiersPayload> = {
  encode(message: ModifiersPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.createdBy !== "") {
      writer.uint32(10).string(message.createdBy);
    }
    if (message.createdAt !== "") {
      writer.uint32(18).string(message.createdAt);
    }
    if (message.modifiedBy !== "") {
      writer.uint32(26).string(message.modifiedBy);
    }
    if (message.modifiedAt !== "") {
      writer.uint32(34).string(message.modifiedAt);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ModifiersPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseModifiersPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.createdAt = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.modifiedBy = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.modifiedAt = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ModifiersPayload {
    return {
      createdBy: isSet(object.createdBy) ? globalThis.String(object.createdBy) : "",
      createdAt: isSet(object.createdAt) ? globalThis.String(object.createdAt) : "",
      modifiedBy: isSet(object.modifiedBy) ? globalThis.String(object.modifiedBy) : "",
      modifiedAt: isSet(object.modifiedAt) ? globalThis.String(object.modifiedAt) : "",
    };
  },

  toJSON(message: ModifiersPayload): unknown {
    const obj: any = {};
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    if (message.createdAt !== "") {
      obj.createdAt = message.createdAt;
    }
    if (message.modifiedBy !== "") {
      obj.modifiedBy = message.modifiedBy;
    }
    if (message.modifiedAt !== "") {
      obj.modifiedAt = message.modifiedAt;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ModifiersPayload>, I>>(base?: I): ModifiersPayload {
    return ModifiersPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ModifiersPayload>, I>>(object: I): ModifiersPayload {
    const message = createBaseModifiersPayload();
    message.createdBy = object.createdBy ?? "";
    message.createdAt = object.createdAt ?? "";
    message.modifiedBy = object.modifiedBy ?? "";
    message.modifiedAt = object.modifiedAt ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
